import PageBreakCta from './page-break-cta'

export default PageBreakCta
